import H from 'constants/httpMethod.const';
import { fromFeeToDto } from 'dto/taxes/fromFeeToDto.dto';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beEditFee = actionEndpointBe('beEditFee', H.patch, 'sales/salon/:salonId/fees/:id/', (options, extra) => ({
  ...options,
  inert: true,
  data: extra?.data,
  params: { id: fromAnyToTrimmed(extra?.id) },
  toDto: fromFeeToDto,
}));
